'use client'
import React, { useState } from 'react'
import { Product } from '@/types'
import ProductPurchase from './ProductPurchase'
import WeightSelector from './WeightSelector'
import SelectProduct from './SelectProduct'
import { Divider } from '@nextui-org/react'

type Props = {
    product: Product
    products: Product[]
}

const ProductOptions = ({ product, products }: Props) => {
    const [is1kg, setIs1kg] = useState(false);
    const [is1kgPricePresent, setIs1kgPricePresent] = useState(!product.price1kg || Number(product.price1kg) <= 0 ? false : true);

    return (
        <>
            <h1 className="text-3xl">
                {product.englishname}
                &nbsp; ({product.name})
            </h1>
            <h2>
                {product.category}&nbsp;
                {
                    product.category == "Premix" &&
                    <>
                        <span className="text-sm text-gray-500">{`(${product.type})`}</span>
                        <br />
                        <WeightSelector is1kg={is1kg} setIs1kg={setIs1kg} is1kgPricePresent={is1kgPricePresent} />
                    </>
                }
                {

                }
            </h2>
            {product.category == "Premix" ? (
                <SelectProduct product={product} is1kg={is1kg} />
            ) : (
                ""
            )}
            <Divider />
            <p>{product.description + " *"}</p>
            <Divider />
            {
                product.isactive == 1 && ((!is1kg && product.outofstock === 0) || (is1kg && product.outofstock1kg === 0)) ? (
                    <ProductPurchase product={product} products={products} is1kg={is1kg} setIs1kg={setIs1kg} />
                ) : (
                    <div>
                        <h2 className="text-xl text-left font-medium text-red-500">
                            {(product.outofstock == 1 || product.outofstock1kg == 1) ? "Out of Stock" : "Product Inactive"}
                        </h2>
                        <p className="text-left">
                            {(product.outofstock == 1 || product.outofstock1kg == 1) ? "Product is currently out of stock" : "Product is currently inactive"}
                        </p>
                    </div>
                )
            }
            <Divider />
        </>
    )
}

export default ProductOptions
